module.exports = __webpack_public_path__ + "img/40.b8fe84a0.jpg";